import { Component, Inject } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddShiftComponent } from '../add-shift/add-shift.component';
import { RecConfirmModalComponent } from '../rec-confirm-modal/rec-confirm-modal.component';
import { ViewEmployeeComponent } from '../../view-employee/view-employee.component';
@Component({
  selector: 'app-new-list-view-details',
  templateUrl: './new-list-view-details.component.html',
  styleUrls: ['./new-list-view-details.component.scss']
})
export class NewListViewDetailsComponent {
  panelOpenState = false;
  public listArr: any[] = []
  expandedPanels: boolean[] = [];

  constructor(
    private recruiterService: RecruiterService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private dilogRef: MatDialogRef<NewListViewDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  }

  ngOnInit() {
    this.list()

  }

  list() {
    let obj = {
      "st_dt": this.data.st_dt,
      // "st_dt": "2024-12-27",
      "j_c": this.data.j_c,
      "r_p": "12",
    }
    this.recruiterService.dateWiseSubcatShift(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.listArr = success.msg;
          // this.expandedPanels = new Array(this.listArr.length).fill(true);

        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      }
    })
  }


  onConfirmationModal(element, type, jobId: any) {
    if (element.app == type) { return }
    let data = {
      type: "shift_request",
      text: "status",
      reqObj: {
        app: type, //1 : accep, 0:reject
        em_i: element.em_i,
        j_id: jobId,

      }
    }
    const dialogRef = this.dialog.open(RecConfirmModalComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", data: data,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.list()
      if (result && result["confirm"] == 'yes') {
      }
    });
  }
  acceptAll(jobId: any) {
    const data = {
      "j_id": jobId
    }
    // this.isSpinnerLoading = true;
    this.recruiterService.onAcceptAllUserForSpecificJob(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  onEdit(item, tabType) {
    let newData = {
      addType: "single",
      modalType: "open_shift",
      // date: item.st_dt,
      date: this.data.st_dt,
      tabType: tabType,
      shift_data: {
        id: item.id,
        // comm_id: item.comm_id,
        em_i: "",
      }
    }
    const dialogRef = this.dialog.open(AddShiftComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      width: '55%',
      height: '98%',
      maxWidth: '90vw',
      autoFocus: false,
      data: newData,
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.list()
    });
  }

  onCloseDilog() {
    this.dilogRef.close()
  }

  onViewEmployee(id) {
    let data = {
      employee_id: id,
      type: 'company'
    }
    const dialogRef = this.dialog.open(ViewEmployeeComponent, {
      width: '95%',
      height: '95vh',
      maxWidth: '95vw',
      panelClass: 'onboard-modal',
      data: data,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
} 
